import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { getInternalUsers } from 'services/apiKYP'
import { CircularProgress } from "@mui/material"
import { toast } from "react-toastify"
import { useHistory } from "react-router-dom"
import styles from './styles'
import { Button, Pagination } from "../../components"
import UserTable from "../../components/InternalUserManagement/UserTable"
import UserSearchBar from "../../components/InternalUserManagement/UserSearchBar"
import { ROUTE_CONSTANTS } from "../../utils/constants/routeConstants"
import { USER_STATUS } from "../../utils/constants/kypStatuses"

const UserManagement = () => {
  const classes = styles()
  const token = useSelector((state) => state.auth.access_token)

  const initialValues = {
    email: null,
    role: null,
    status: null, // disabled
  }

  const history = useHistory()
  const [users, setUsers] = useState([])
  const [itemsCount, setItemsCount] = useState(0)
  const [currentPage, setCurrentPage] = useState(0)
  const [size, setSize] = useState(10)

  const [searchParams, setSearchParams] = useState(initialValues)

  const [isLoading, setIsLoading] = useState(false)

  const fetchData = () => {
    const params = {
      params: {
        page: currentPage + 1,
        size,
        role: searchParams.role,
      },
    }

    if (searchParams.status !== null) {
      params.params.disabled = searchParams.status === USER_STATUS.DISABLED
    }

    if (searchParams.email !== null && searchParams.email.length > 0) {
      params.params.email = searchParams.email
    }
    
    setIsLoading(true)

    getInternalUsers(token, params)
      .then((response) => {
        const { data } = response
        setUsers(data?.items)
        setItemsCount(data?.total)
      })
      .catch((error) => {
        setUsers([])
        setItemsCount(0)
        if (error.response && error.response.data && error.response.data.detail) {
          toast.error(error.response.data.detail)
        } else {
          toast.error("Erro ao obter os dados do servidor. Por favor, tente novamente mais tarde.")
        }
      })
      .finally(() => setIsLoading(false))
  }

  const handlePageChange = (event, page) => {
    setCurrentPage(page)
  }

  const handleChangeRowsPerPage = (event) => {
    setSize(event.target.value)
    setCurrentPage(0)
  }

  const handleChangeSearchParams = (value) => {
    setSearchParams(value)
    setCurrentPage(0)
  }

  const handleAdd = () => {
    history.push({
      pathname: ROUTE_CONSTANTS.USER_EDITOR,
    })
  }

  useEffect(() => {
    fetchData()
  }, [token, searchParams, currentPage, size])

  return (
    <div className={classes.root}>
      <div className={classes.topBar}>
        <UserSearchBar setSearchParams={handleChangeSearchParams} />
        <Button onClick={handleAdd}>
          Adicionar
        </Button>
      </div>

      {isLoading ? (
        <div className={classes.loading}>
          <CircularProgress size={64} color="primary" />
          <span className={classes.loadingText}>
            Buscando usuários...
          </span>
        </div>
      ) : (
        <React.Fragment>
          <div className={classes.tableContainer}>
            <UserTable users={users} />
          </div>
          {users?.length > 0 && (
            <Pagination
              count={itemsCount}
              component="div"
              page={currentPage}
              rowsPerPage={size}
              rowsPerPageOptions={[10, 15, 20, 25, 30]}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </React.Fragment>
      )}
    </div>
  )
}

export default UserManagement
